import * as React from 'react';
import { useMemo } from 'react';

import { getAssetFromString } from 'helpers/assets';

import IconMinus from 'assets/icons/nav/icon-minus-6.svg';
import IconPlus from 'assets/icons/nav/icon-plus-6.svg';

import AssetLogo from 'basics/AssetLogo';

import { ActionBadge, ActionIcon, Container } from './ActiveAssetProposal.styled';

import { HeaderProposal } from '../Header.types';

const ActiveAssetProposal = ({ proposal }: { proposal: HeaderProposal }): React.ReactNode => {
    const asset = useMemo(
        () =>
            getAssetFromString(
                proposal.asset_code
                    ? `${proposal.asset_code}:${proposal.asset_issuer}`
                    : proposal.asset_contract_address,
            ),
        [proposal.asset_code, proposal.asset_issuer, proposal.asset_contract_address],
    );
    const isRemove = proposal.proposal_type === 'REMOVE_ASSET';

    return (
        <Container data-testid="header-asset-proposal">
            <AssetLogo asset={asset} size={2.4} fallbackImage={proposal.image} />
            <ActionBadge $isRemove={isRemove}>
                <ActionIcon>{isRemove ? <IconMinus /> : <IconPlus />}</ActionIcon>
            </ActionBadge>
        </Container>
    );
};

export default ActiveAssetProposal;
